<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-1">
<div class="heading heading-with-title heading-without-image" id="chapter-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-with-element-number">
<div class="element-number-block">
<div class="element-number">1</div>
</div>
<div class="title-block">
<h1 class="title">GERMANY</h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-1-text">
<p class="first first-in-chapter first-full-width"><i><span class="drop-cap">H</span>e’s dying.</i></p>
<p class="subsq"><i>It’s quiet in this corner of the park, just him and you. His fingers dig into the short turf, grinding dirt underneath his nails, as he struggles to take his last breath. A violent twitching sets up in his left Lycra-clad leg, then stops. Breath gurgles and chokes. His body relaxes, then slumps.</i></p>
<p class="subsq"><i>He’s gone.</i></p>
<p class="subsq"><i>All you can hear now is birdsong. There’s a pale dawn lighting up the eastern sky and a bitter spring chill in the air. The ground is faintly frosted. Your breath forms pale clouds and you look down at your prey.</i></p>
<p class="subsq"><i>Six down, more than twenty left to go.</i></p>
<p class="subsq"><i>You check the lid is tight on your aerosol and slip it back into your pocket. Cyanide spray. One of your favourite methods. They won’t find any trace of it unless they are looking for it. A runner collapses. They’ll suspect natural causes. Of course, the post-mortem will be inconclusive, but there’ll be nothing to suggest foul play. Nothing to suggest that he might have been murdered.</i></p>
<p class="subsq"><i>Yet you linger, looking down on his now still form. His running kit is cheap, high street stuff. The Fitbit on his wrist will confirm his time of death. His headphones came out in the struggle and lie tangled around him. His phone is still strapped to his upper arm. The playlist will continue, with no one to hear it. The sound is tinny but you recognise the tone. German folk rock. Well, what else?</i></p>
<p class="subsq"><i>You should be gone now. Leave this place, leave his body for the next runner to find. There’s no CCTV in this part of the park. Nothing to capture the moment he fell. Nothing to show the figure that stepped out beside him, aerosol spray in hand. Nothing to show you approaching this place.</i></p>
<p class="subsq"><i>And nothing to show you leave.</i></p>
<p class="subsq"><i>Should you feel something? Standing there, looking down at this morning’s work. Has killing become so routine? An art form – a skill to take pride in? Perhaps. And yet here you are, savouring the moment, a faint thrill tingling its way up and down your spine.</i></p>
<p class="subsq"><i>A blackbird calls, a trill warning. Probably just a cat, but it’s enough to stir you out of the moment.</i></p>
<p class="subsq"><i>You slip away between the trees, a shadowy figure. You were never here.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter001.vue?423cf171